<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">corporate culture</div>
      <div class="contentTitle">企业文化</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="itemBox">
        <div class="item" v-for="(item, index) in itemArr" :key="index">
          <div class="itemImg">
            <div class="itemRadius">
              <img :src="item.url" alt />
            </div>
            <div class="itemTitle">{{ item.title }}</div>
          </div>
          <div class="itemTotal">{{ item.total }}</div>
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentStitle">corporate culture</div>
      <div class="contentTitle">企业文化</div>
      <div class="itemBox">
        <div class="item">
          <div class="item_left">
            <div class="itemRadius">
              <img :src="src.yuanjing" alt />
            </div>
            <div class="item_title">愿景</div>
          </div>
          <div class="item_Right">打造值得全球信赖的就业服务平台</div>
        </div>
        <div class="item">
          <div class="item_Right">用心服务 筑就行业新高度</div>
          <div class="item_left">
            <div class="itemRadius">
              <img :src="src.shiming" alt />
            </div>
            <div class="item_title">使命</div>
          </div>
        </div>
        <div class="item">
          <div class="item_left">
            <div class="itemRadius">
              <img :src="src.jiazhiguan" alt />
            </div>
            <div class="item_title">价值观</div>
          </div>
          <div class="item_Right">诚信 责任 共赢 感恩</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      itemArr: [
        {
          url: src.yuanjing,
          title: "愿景",
          total: "打造值得全球信赖的就业服务平台",
        },
        {
          url: src.shiming,
          title: "使命",
          total: "用心服务 筑就行业新高度",
        },
        {
          url: src.jiazhiguan,
          title: "价值观",
          total: "诚信 责任 共赢 感恩",
        },
      ],
      src: src,
    };
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 999px) {
  .itemBox {
    padding: 20px;
    .item {
      display: flex;
      height: 120px;
      margin-bottom: 10px;
      .item_left {
        width: 45%;
        background: #eeeeee;
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        .itemRadius {
          width: 60px;
          height: 60px;
          background: #da261d;
          border-radius: 50%;
          margin: 0 auto;
          margin-top: 20px;
          padding-top: 10px;
          img {
            width: 40px;
          }
        }
        .item_title {
          margin-top: 10px;
          font-weight: 700;
        }
      }
      .item_Right {
        width: 55%;
        background: #fdfdfd;
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        line-height: 100px;
      }
    }
  }
}
@media screen and (min-width: 1000px) {
  .itemBox {
    display: flex;
    justify-content: center;
    margin-top: 100px;
    .item {
      margin-right: 120px;
      .itemImg {
        width: 270px;
        height: 257px;
        background: #eeeeee;
        padding-top: 34px;
        .itemRadius {
          width: 136px;
          height: 136px;
          background: #da261d;
          border-radius: 50%;
          margin: 0 auto;
          padding-top: 20px;
        }
        .itemTitle {
          font-size: 22px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #000000;
          margin-top: 40px;
        }
      }
      .itemTotal {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #000000;
        line-height: 28px;
        margin: 40px 0 100px;
      }
    }

    .item:nth-child(3) {
      margin-right: 0;
    }
  }
}
</style>
